// extracted by mini-css-extract-plugin
module.exports = {"block":"contacts_block__3L6t-","text":"contacts_text__3ps2y"};